module.exports = __webpack_public_path__ + "img/logo-umia.b2aac35f.jpg";